<template>
<div id="clientes_certificaciones">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="Claves Distitnas" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">

              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="getRegistro(props.row.id)" title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="deleteRegistro(props.row.id)" title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  
  <v-dialog v-model="modal" max-width="30%" style=" z-index: 400 !important;">
        <v-card>
        <v-card-title>
            <v-card class="primary white--text titulomodal">
            <v-icon class="white--text" @click.native="modal = false">cancel</v-icon>&nbsp;
            <span class="subheading">
                <strong>{{ update ? "Actualizar" : "Nueva" }} Clave</strong>
            </span>
            </v-card>

        </v-card-title>
        <v-form ref="form" lazy-validation>
            <v-card-text>
            <br>
            <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar()">
                <v-row row wrap>
                <v-col sm="12">
                    <v-autocomplete v-model="model.clave" :items="claves" item-text="text" item-value="value" label="Clave" @change="model.prefijo = '';"/>
                </v-col>
                <v-col sm="12" v-if="model.clave == 'CTM'">
                    <v-text-field v-model="model.prefijo" label="Prefijo" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col sm="12">
                    <v-text-field rows="1" label="Descripción" auto-grow v-model="model.descripcion" :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col sm="12">
                    <v-autocomplete value="0" v-model="model.periodo" :items="periodicidad" item-text="text" item-value="value" label="Periodicidad" />
                </v-col>
                </v-row>
            </v-container>
            </v-card-text>
        </v-form>
        <v-card-actions>
            <v-btn @click.native="modal = false">
            <v-icon>cancel</v-icon> Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="loading" @click.native="guardar()">
            <v-icon>done</v-icon>
            {{ update ? "Actualizar" : "Guardar" }}
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  data: vm => ({
    name: "datagrid",
    select_activo: [{
      "value": 0,
      "text": "Excluir"
    }, {
      "value": 1,
      "text": "Incluir"
    }],
    claves: [{
      "value": "CTM",
      "text": "CTM"
    }, {
      "value": "DON",
      "text": "DON"
    },
    {
      "value": "DES",
      "text": "DES"
    },
    {
      "value": "CFDI",
      "text": "CFDI"
    }],
    periodicidad: [{
      "value": "Mensual",
      "text": "Mensual"
    }, {
      "value": "Bimestreal",
      "text": "Bimestral"
    }],
    columns: [
      "clave",
      "prefijo",
      "descripcion",
      "periodo",
      "actions"
    ],
    show_loading: true,
    options: {
      filterable: [],
      sortable: [
        "clave",
        "descripcion",
        "periodo",
        "prefijo",
      ],
      headings: {
        clave: "Clave",
        descripcion: "Descripción",
        prefijo: "Prefijo",
        periodo: "Periodicidad",
        actions: "Operaciones"
      }
    },
    URL: "",
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Claves Distintas",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    update: false,
    model: {},
    rules: {
      required: v => !!v || "Este campo es requerido"
    },
    items: [],
  }),
  methods: {
    clean_model: function() {
      return {
        id: null,
        id_cliente: this.$local_storage.get("id_cliente"),
        clave:null,
        prefijo:"",
        descripcion: null,
        periodo: null,
        id_usuario: this.$local_storage.get("id_usuario"),
      }
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    openModal: function(type) {
      if (type === 1) {
        this.model = this.clean_model();
        this.title = "Nuevo Registro";
        this.update = false;
      } else {
        this.title = "Actualizar Registro";
        this.update = true;
      }
      this.modal = true;
    },
    guardar() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var metodo = "post";
        var urlCliente = this.URL + "guardar/";
        if (this.update == true) {
          metodo = "post";
          urlCliente = this.URL + "actualizar/";
        }
        axios({
            method: metodo,
            url: urlCliente,
            data: this.model
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
          })
          .catch(error => {
            var mensaje = "Ocurrió un error al guardar los datos";
            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
              mensaje = error.response.data.mensaje;
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: mensaje,
              footer: '',
            });
            console.log(error);
          })
          .then(() => {
            this.cargar();
            this.$root.$dialogLoader.hide();
            this.modal = false;
          });
      }
    },
    cargar: function() {
      axios
        .post(this.URL + "listar/", {
          "id_cliente": this.$local_storage.get("id_cliente")
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    getRegistro: function(id_registro) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .post(this.URL + "listar/", {
          "id": id_registro,
          "id_cliente": this.$local_storage.get("id_cliente")
        })
        .then(response => {
          this.model = response.data;
          this.openModal(2); //ACTUALIZAR
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro" + error,
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro
    deleteRegistro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value)
          axios
          .post(this.URL + "eliminar/", {
            "id": id_registro
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El registro se eliminó correctamente.",
              //position: 'bottom-end',
              //timer: 3000,
              //showConfirmButton: false,
              footer: ""
            });
            this.cargar();
          })
          .catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al eliminar el registro",
              footer: ""
            });
          });
      });
    }, //delete
  }, //methods
  created: function() {
    this.URL = this.$apiSA31 + "soluciona31/catalogos/claves_distintas/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.cargar();
  }
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
